module.exports = __webpack_public_path__ + "static/LiNKX_logo-01-850f96ae73eaf452b880e66849bf30ac.png";